import { IHttpService, IPromise } from 'angular';
import { GmcApi } from '../../constants/gmc-api';
import { IVesselSectionsRes } from './job-rank.interfaces';
import { cloneDeep } from 'lodash-es';
import { IDataMap } from '../../interfaces/data-map.interface';


export interface IVesselJobsData {
  vesselSections: IVesselSection[];
  vesselTypes: IVesselType[];
  vesselJobs: IVesselJob[];
  vesselSectionsMap: IVesselSection;
  vesselTypesMap: IVesselType;
  vesselJobsMap: IVesselJob;
}

export interface IVesselJob {
  _id?: string;
  name?: string;
  vessel_type_id?: string;
  section_id?: string;
}

export interface IVesselType {
  _id?: string;
  name?: string;
  section_id?: string;
}

export interface IVesselSection {
  _id?: string;
  name?: string;
}

export class JobRankService {
  static $inject = [
    '$http',
    'GmcApi',
    '$q'
  ];
  data: IVesselJobsData;
  sectionsSettings = {
    namesRemap: {
      'Oil&Gas': 'Oil & Gas'
    },
    order: [
      'Oil & Gas',
      'Offshore Fleet',
      'Main Fleet',
      'Onshore'
    ]
  };
  private vesselSections: IVesselSection[] = [];
  private vesselTypes: IVesselType[] = [];
  private vesselJobs: IVesselJob[] = [];
  private vesselSectionsMap: IDataMap<IVesselSection> = {};
  private vesselTypesMap: IDataMap<IVesselType> = {};
  private vesselJobsMap: IDataMap<IVesselJob> = {};

  constructor( private $http: IHttpService,
               private gmcApi: GmcApi ) {
  }

  fetchVesselJobs(): IPromise<IVesselJobsData> {
    return this.$http.get<any>(this.gmcApi.helpers.getRanks)
      .then(( res ) => {
        console.log(res);
        this.data = this.transformResponse(res.data.sections);
        console.log(this.data);
        return this.data;
      });
  }

  getVesselJobs(): IVesselJobsData {
    return cloneDeep(this.data);
  }

  getVesselSectionsMap(): IDataMap<IVesselSection> {
    return cloneDeep(this.vesselSectionsMap);
  }

  getVesselTypesMap(): IDataMap<IVesselType> {
    return cloneDeep(this.vesselTypesMap);
  }

  getVesselJobsMap(): IDataMap<IVesselJob> {
    return cloneDeep(this.vesselJobsMap);
  }


  findVesselSectionById( id: string ): IVesselSection {
    for ( const section of this.data.vesselSections ) {
      if ( section._id === id ) {
        return cloneDeep(section);
      }
    }
    return null;
  }

  findVesselTypeById( id: string ): IVesselType {
    for ( const vesType of this.data.vesselTypes ) {
      if ( vesType._id === id ) {
        return cloneDeep(vesType);
      }
    }
    return null;
  }

  findJobById( id: string ): IVesselJob {
    for ( const job of this.data.vesselJobs ) {
      if ( job._id === id ) {
        return cloneDeep(job);
      }
    }
    return null;
  }

  findJobsByVesselTypeId( vesselTypeId: string ): IVesselJob[] {
    return cloneDeep(this.data.vesselJobs.filter(( job ) => job.vessel_type_id === vesselTypeId));
  }

  findJobsByVesselSectionId( vesselSectionId: string ): IVesselJob[] {
    return cloneDeep(this.data.vesselJobs.filter(( job ) => job.section_id === vesselSectionId));
  }

  findVesselTypesBySectionId( sectionId: string ): IVesselType[] {
    return cloneDeep(this.data.vesselTypes.filter(( vesType ) => vesType.section_id === sectionId));
  }

  private transformResponse( data: IVesselSectionsRes[] ) {
    this.vesselSections = [];
    this.vesselTypes = [];
    this.vesselJobs = [];
    this.vesselSectionsMap = {};
    this.vesselTypesMap = {};
    this.vesselJobsMap = {};
    const result: IVesselJobsData = {
      vesselSections: [],
      vesselTypes: [],
      vesselJobs: [],
      vesselSectionsMap: {},
      vesselTypesMap: {},
      vesselJobsMap: {}
    };
    console.log(data);

    data.sort(( prev, next ) => {
      return this.sectionsSettings.order.indexOf(prev.name) - this.sectionsSettings.order.indexOf(next.name);
    });

    for ( const section of data ) {
      const formattedSection: IVesselSection = {
        name: this.renameSectionName(section),
        _id: section._id
      };
      this.vesselSections.push(formattedSection);
      this.vesselSectionsMap[ section._id ] = formattedSection;
      for ( const vesselType of section.vessel_types ) {
        const formattedVesselType: IVesselType = {
          _id: vesselType._id,
          name: vesselType.name,
          section_id: formattedSection._id
        };
        this.vesselTypes.push(formattedVesselType);
        this.vesselTypesMap[ vesselType._id ] = formattedVesselType;
        for ( const job of vesselType.jobs ) {
          const formattedJob: IVesselJob = {
            _id: job._id,
            name: job.name,
            section_id: formattedSection._id,
            vessel_type_id: formattedVesselType._id
          };
          this.vesselJobs.push(formattedJob);
          this.vesselJobsMap[ formattedJob._id ] = formattedJob;
        }
      }
    }
    console.log(this.vesselSections);
    result.vesselSections = this.vesselSections;
    result.vesselTypes = this.vesselTypes;
    result.vesselJobs = this.vesselJobs;
    result.vesselSectionsMap = this.vesselSectionsMap;
    console.log(this.vesselSectionsMap);
    result.vesselTypesMap = this.vesselTypesMap;
    result.vesselJobsMap = this.vesselJobsMap;
    return result;
  }

  private renameSectionName( section: IVesselSection ): string {
    return this.sectionsSettings.namesRemap[ section.name ] || section.name;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/job-rank/job-rank.service.ts